import React from 'react'
import FirstLoadController from '../../components/FirstLoadController'
import Samples from './Samples'

export default function (props: Props) {
  return (
    <FirstLoadController active={props.active}>
      <Samples {...props} />
    </FirstLoadController>
  )
}
